<template>
    <!-- Loading -->
    <div id="overlay">
        <div class="caja">
            <div id="loader">
                <div id="circle1" class="rotate-scale-up"></div>
                <div id="circle2" class="rotate-scale-up"></div>
            </div>
            <div class="loader_text">
                <h4>Cargando...</h4>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VsudLoading",
};
</script>

<style></style> 
